export default "__VITE_ASSET__CaGUkFau__"